export const SWITCH_DIRECTION = 'row-reverse';
export const FORM_MARGIN = '15px 0 20px 0';

export const SUPPORT_LINKS = {
  codeAdv: 'https://support.scrappbook.de/de/articles/61943',
  abandonedCart: 'https://support.scrappbook.de/de/articles/61945',
  emptyCartSuggestion: 'https://support.scrappbook.de/de/articles/61946',
  freeShipping: 'https://support.scrappbook.de/de/articles/61947',
  afterPurchase:
    'https://support.scrappbook.de/de/articles/61948-automatischer-gutscheincode-nach-dem-kauf',
  marketingPhotobook:
    'https://support.scrappbook.de/de/articles/413183-fotobuch-marketing-aktivieren-und-nutzen'
};
